import getApiClient from '@/plugins/api-client'

export default {
    loadSymplaEvents: function() {
        const self = this,
            api = getApiClient(self.$store)

        let params = {
            page: self.currentPage,
            itemsPerPage: self.itemsPerPage
        }

        api.get('sympla_events', {params})
            .then(result => {
                self.symplaEvents = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.itemsPerPage)
            })
            .catch(error => {
                console.log(error)
            })
    },

    showDeleteConfirmation(id) {
        this.deleteSymplaEvent = id
        this.showDeleteConfirmationModal = true
    },

    deleteModal() {
        const self = this,
            api = getApiClient(self.$store),
            id = self.deleteSymplaEvent

        api.delete(`sympla_events/${id}`)
            .then(() => {
                self.deleteSymplaEvent = null
                self.showDeleteConfirmationModal = false
                self.loadSymplaEvents()
            })
            .catch(error => {
                console.log(error)
            })
    },

    cancelDeleteModal() {
        this.deleteSymplaEvent = null
        this.showDeleteConfirmationModal = false
    },

    syncEvent(event) {
        const self = this,
            api = getApiClient(self.$store)

        self.syncingEvent = event.id

        api.patch(`sympla_events/${event.id}/sync`, {}, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(() => {
                self.loadSymplaEvents()

                self.$refs.snackbar.info(`Evento ${event.name} atualizado`);
            })
            .catch(error => {
                self.$refs.snackbar.error(`Falha ao atualizar ${event.name}`);
                console.log(error)
            })
            .finally(() => {
                self.syncingEvent = null
            })
    },

    updatePage: function(page) {
        this.currentPage = page
    }
}
